import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tabs, BackTop } from 'antd';
import Dashboard from './Dashboard';
import DimensionAnalysis from '../DimensionAnalysis';
import moment from 'moment';

const { TabPane } = Tabs;
const { curRole } = sessionStorage;
const panes = [{
    title: '规模',
    key: 'scale',
}, {
    title: '效率',
    key: 'efficiency',
}, {
    title: '运营监控',
    key: 'operationMonitor',
}]

curRole !== 'HRRC' && curRole != 'HRRC' && panes.push({
    title: '进度差异',
    key: 'scheduleVariance',
})

class ProjectIndicatorAnalysis extends Component {
    static childContextTypes = {
        moduleType: PropTypes.string,
        activeKey: PropTypes.string,
        business: PropTypes.array,
        contractType: PropTypes.array,
        systemDate: PropTypes.object,
        handleExpand: PropTypes.func,
    }

    constructor(props) {
        super(props);
        this.panes = [...panes];
        this.state = {
            activeKey: 'scale',
            moduleType: '',
            params:{}
        };
    }

    getChildContext = () => {
        const { business, contractType, systemDate } = this.props;
        const { moduleType, activeKey } = this.state;
        return {
            moduleType,
            activeKey,
            business,
            contractType,
            systemDate,
            handleExpand: this.handleExpand
        };
    }

    handleExpand = (moduleType,params) => {
        this.setState({ moduleType}
            );
        if(params){
            const{statisticalRange,lineOfBusiness}=params;
            params.analysisDimension = statisticalRange=="PROJECT"?"PROJECT_AREA":'GLOBAL';
            params.year = moment((params&&params.statisticDate).toString()).format("YYYY");
            this.setState({ selectParams:{...params,statisticDate:null} });
        }    
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey });
    }

    getContent = (pane) => {
        const { activeKey } = this.state;
        if (pane.key === activeKey) {
            return (
                <Dashboard />
            );
        } else {
            return null;
        }
    }

    render() {
        const { activeKey, moduleType,selectParams } = this.state;
        const{financeIndicatorAnalysis,projectIndicatorAnalysis}=this.props;
        return (
            <div className="tabWidth homePageTab" style={{ marginTop: -16 }}>
                {
                    !moduleType ?
                        <Tabs activeKey={activeKey} onChange={this.handleTabsChange}>
                            {this.panes.map(pane => <TabPane tab={pane.title} key={pane.key} disabled={pane.disabled}>{this.getContent(pane)}</TabPane>)}
                        </Tabs>
                    :
                        <DimensionAnalysis source="project" 
                        selectParams={selectParams} 
                        financeIndicatorAnalysis={financeIndicatorAnalysis} 
                        projectIndicatorAnalysis={projectIndicatorAnalysis} 
                        />
                }
                <BackTop />
            </div>
        );
    }
}

export default ProjectIndicatorAnalysis;


// WEBPACK FOOTER //
// ./src/components/homePage/projectIndicatorAnalysis/index.js